<div #boardParentDiv>
  <app-chessboard-view #chessboard [fen]="chess.fen()" (playedMove)="onPlayedMove($event)"></app-chessboard-view>
</div>
